import { render, staticRenderFns } from "./comparison-table-visitors.view.vue?vue&type=template&id=9cabf0f6&scoped=true&"
import script from "./comparison-table-visitors.view.vue?vue&type=script&lang=ts&"
export * from "./comparison-table-visitors.view.vue?vue&type=script&lang=ts&"
import style0 from "./comparison-table-visitors.view.vue?vue&type=style&index=0&id=9cabf0f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cabf0f6",
  null
  
)

export default component.exports